import { render, staticRenderFns } from "./modele_facture.vue?vue&type=template&id=49862fa0&scoped=true&"
import script from "./modele_facture.vue?vue&type=script&lang=js&"
export * from "./modele_facture.vue?vue&type=script&lang=js&"
import style0 from "./modele_facture.vue?vue&type=style&index=0&id=49862fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49862fa0",
  null
  
)

export default component.exports